import { render, staticRenderFns } from "./sidebar-right.vue?vue&type=template&id=d444f54c&scoped=true&"
import script from "./sidebar-right.vue?vue&type=script&lang=js&"
export * from "./sidebar-right.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-right.vue?vue&type=style&index=0&id=d444f54c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d444f54c",
  null
  
)

export default component.exports